var map = {
	"./assistant/banner.vue": "c7df",
	"./assistant/header.vue": "ad8c",
	"./assistant/index.vue": "5f68",
	"./assistant/message/assistant.vue": "513b",
	"./assistant/message/suggested.vue": "6a9f",
	"./assistant/message/user.vue": "e456",
	"./assistant/messages.vue": "9417",
	"./assistant/presentations/big.vue": "d96b",
	"./assistant/presentations/finished.vue": "3c3d",
	"./assistant/presentations/permissions.vue": "68dc",
	"./assistant/presentations/small.vue": "cd23",
	"./assistant/suggesteds/items/card.vue": "1b5f",
	"./assistant/suggesteds/items/modal.vue": "af41",
	"./assistant/suggesteds/stores/card.vue": "7a19",
	"./assistant/suggesteds/stores/modal.vue": "de5f",
	"./cart/button.vue": "eaad",
	"./cart/checkout/menu/bancard-register.vue": "f747",
	"./cart/checkout/menu/bancard.vue": "3d2d",
	"./cart/checkout/menu/bank-transfer.vue": "52e1",
	"./cart/checkout/menu/cash.vue": "e0db",
	"./cart/checkout/menu/mercadopago-online.vue": "4d44",
	"./cart/checkout/menu/promocode.vue": "30b56",
	"./cart/checkout/menu/schedule.vue": "9894",
	"./cart/checkout/payment.vue": "1dae",
	"./cart/checkout/payment/bancard.vue": "8f1b",
	"./cart/checkout/payment/bank-transfer.vue": "6f1d",
	"./cart/checkout/payment/cash.vue": "488c",
	"./cart/checkout/payment/mercadopago-online.vue": "a54b",
	"./cart/checkout/payment/none.vue": "f445",
	"./cart/checkout/payment/pos-mobile.vue": "0481",
	"./cart/checkout/type.vue": "df00",
	"./cart/checkout/when.vue": "2197",
	"./cart/item.vue": "aae2",
	"./catalog/additional/card.vue": "d1e1",
	"./catalog/additional/checkbox.vue": "ac94",
	"./catalog/additional/spinbox.vue": "3222",
	"./catalog/group.vue": "b7ca",
	"./catalog/index.vue": "8f01",
	"./catalog/item/card.vue": "61df",
	"./catalog/section.vue": "f060",
	"./code/button.vue": "5e7d",
	"./common/button/back.vue": "0461",
	"./common/footer/microsite.vue": "7ed5",
	"./common/footer/minimum.vue": "0bc9",
	"./common/form/input/phone.vue": "5e40",
	"./common/logo/main.vue": "b347",
	"./common/menu/main.vue": "57a2",
	"./common/message/empty.vue": "351f",
	"./common/message/error.vue": "0752",
	"./common/message/info.vue": "6a1a",
	"./common/message/loading-small.vue": "cdcb",
	"./common/message/loading.vue": "368b",
	"./common/message/powered.vue": "a0b4",
	"./common/modal/image.vue": "3459",
	"./common/modal/redirect.vue": "43a3",
	"./discount/show.vue": "9dde",
	"./empty.vue": "d138",
	"./home/location.vue": "0364",
	"./layouts/basic.vue": "93fe",
	"./layouts/cart/complete.vue": "a059",
	"./layouts/cart/minimum.vue": "be47e",
	"./layouts/cart/nano.vue": "9aa2",
	"./layouts/form/input/general.vue": "25ac",
	"./layouts/identify.vue": "a58e",
	"./layouts/loading.vue": "3dc9",
	"./layouts/main.vue": "7599",
	"./layouts/minimum.vue": "91dd",
	"./layouts/store/minimum.vue": "0ec6",
	"./layouts/store/themes/default.vue": "6a22",
	"./layouts/store/themes/name-only.vue": "db8f",
	"./orders/card.vue": "40c7",
	"./orders/cardSkeletor.vue": "7abb",
	"./orders/item.vue": "7d90",
	"./permissions/install.vue": "dee4",
	"./permissions/notifications.vue": "f5ce",
	"./store/card/header.vue": "fca3",
	"./store/card/main.vue": "e2eb",
	"./store/card/small.vue": "c66b",
	"./store/core.vue": "c895",
	"./store/info.vue": "a249",
	"./store/status.vue": "fa3c",
	"./store/stories/avatar.vue": "dcf7",
	"./store/stories/list.vue": "0c2b",
	"./store/stories/view.vue": "4f1d",
	"./store/type/headquarters/index.vue": "b30d",
	"./store/type/market/index.vue": "4fbd",
	"./stores/list.vue": "2c36",
	"./stores/marketing/items/card.vue": "b4e7",
	"./stores/marketing/items/index.vue": "24be",
	"./stores/marketing/items/modal.vue": "f860",
	"./user/identify/button/email.vue": "964e",
	"./user/identify/button/facebook.vue": "c57c",
	"./user/identify/button/google.vue": "a885",
	"./user/identify/button/phone.vue": "a2ef",
	"./user/identify/modal/google.vue": "d4e8",
	"./user/location/button.vue": "60b6",
	"./user/location/card.vue": "7b03",
	"./user/location/cardSkeletor.vue": "4a5c",
	"./user/location/selected.vue": "7086",
	"./user/phone/input.vue": "666f",
	"./user/status/avatar.vue": "bdea",
	"./user/status/index.vue": "20a0",
	"./user/status/menu.vue": "f967",
	"./user/status/modal/logout.vue": "c706"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ae9";